import {CookieConfig} from 'types/Cookie'

import {cookieSecuritySettings} from '../../utils/cookies/cookieSecuritySettings'

/**
 * Gets cookie options from a cookie configuration.
 * @param cookieConfig - The cookie configuration object
 * @returns The cookie options extracted from the configuration
 */
export const getCookieOptions = (cookieConfig: CookieConfig) => {
  const {secure, sameSite, maxAge: expires, domain} = cookieConfig.options
  return {
    expires,
    secure,
    sameSite,
    domain
  }
}

const options = {
  maxAge: 365 * 2, // 2 years
  ...cookieSecuritySettings(true)
}

/**
 * Configuration for the app locked anchor deal impressions count cookie.
 */
export const appLockedAnchorDealImpressionsCountConfig = {
  name: 'appLockedAnchorDealImpressionsCount',
  options
}

/**
 * Configuration for the first app locked anchor deal impressions timestamp cookie.
 */
export const firstAppLockedAnchorDealImpressionsTimestampConfig = {
  name: 'firstAppLockedAnchorDealImpressionsTimestamp',
  options
}

/**
 * Configuration for the last app locked anchor deal impressions timestamp cookie.
 */
export const lastAppLockedAnchorDealImpressionsTimestampConfig = {
  name: 'lastAppLockedAnchorDealImpressionsTimestamp',
  options
}
